module.exports = __webpack_public_path__ + "static/media/justKidding-2.88cd7142.ogg";